// Wrapper to make lazy-loading a little easier. Specifically removes the need to differentiate module name and export name (which are often the same).
// E.g. allows callers to call alias.export instead of alias.class.export (Telemetry.Telemetry.logEvent)
export async function lazyLoadModule(moduleToLoad) {
    return (await moduleToLoad).default;
}
;
// Including this for completeness: Please do not uncomment or use this code.
// Specifying exports in this way bypasses compile time type checks. This is is a Very Bad Thing To Do.
// 1. Calling with an incorrect will compile fine, but generate runtime apperrors. Depending on what you are doing, the app
// may even appear to function normally
// 2. Because of the above, it makes refactoring or code cleanup extremely dangerous and error prone
//export async function lazyLoadModule<T>(namedExport: string, moduleToLoad: Promise<T>) {
//    return (await moduleToLoad)[namedExport];
//};
